var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17.039,
    r: 1,
    transform: "rotate(-180 12 17.04)",
    fill: "#1E2356"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.04v-7m10 5c0 5.522-4.477 10-10 10s-10-4.478-10-10c0-5.524 4.477-10 10-10s10 4.476 10 10z",
    stroke: "#1E2356",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgWarning;